import React from 'react';
import { Platform } from 'react-native';
import { Trans } from '@lingui/macro';
import { useNavigation } from '@react-navigation/native';
import styled, { css } from 'styled-components/native';

import Shortcut from './Shortcut';

const Container = styled.View`
  flex-direction: row;
  justify-content: center;
  ${Platform.select({
    default: css`
      margin-top: 30px;
    `,
    web: css`
      margin-top: 10px;
    `,
  })};
`;

const Shortcuts: React.FC = () => {
  const navigation = useNavigation();

  return (
    <Container>
      <Shortcut
        icon="umbrella-beach"
        onPress={() => navigation.navigate('ToursStack')}
      >
        <Trans>Tours</Trans>
      </Shortcut>
      <Shortcut icon="book" onPress={() => navigation.navigate('PrimeHome')}>
        <Trans>Guide Books</Trans>
      </Shortcut>
      <Shortcut
        icon="immigration"
        onPress={() => navigation.navigate('ImmigrationHome')}
      >
        <Trans>Immigration Guide</Trans>
      </Shortcut>
    </Container>
  );
};

export default React.memo(Shortcuts);
